import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { max } from 'lodash';
import { AvailableModulesItemCount, TenantDto } from 'projects/shared/src/lib/models/TenantDto';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { AddProjectModulesDialogComponent } from '../add-project-modules-dialog/add-project-modules-dialog.component';
import { ProjectDto } from 'projects/shared/src/lib/models/Project';
import { BookedProjectModules } from 'projects/shared/src/lib/models/ProjectModel';

@Component({
  selector: 'project-contract-info',
  templateUrl: './edit-project-contract.component.html',
  styleUrls: ['./edit-project-contract.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EditProjectContractComponent implements OnInit {
  @Input('project') project!:ProjectDto;
  
  editProjectForm!:FormGroup;
  bookedModules: BookedProjectModules[] = [];
  oldBookedModules: BookedProjectModules[] = [];

    constructor(private fb: FormBuilder, 
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private tenantService: TenantService,
    public translate: TranslateService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    // this.tenantService.currentTenantName = this.tenant.name;
    // this.tenantService.currentTenantId = this.tenant.id;
  
    const json = this.project.bookedModules;
    if (json) {
      this.bookedModules = JSON.parse(json);
      this.oldBookedModules = [...this.bookedModules];
    }
    this.buildProjectForm(this.project);
  }

  buildProjectForm(project: ProjectDto) {
    this.editProjectForm = this.fb.group({
      id:[project.id],
      name:[project.name],
      bookedModules: [project.bookedModules],
      //isForSystemTest: [tenant.isForSystemTest]
    })
  }

  saveBooking(){
    if(this.editProjectForm.valid){
      let project = new ProjectDto;
      project = this.project;
      project.bookedModules = this.editProjectForm.value.bookedModules;
      console.log("-------> saveBooking project with booked modules: ", project.bookedModules );

      //test
        // var newModules = this.checkModulesAdded(this.oldBookedModules, this.bookedModules);
        // var removedModules = this.checkModulesRemoved(this.oldBookedModules, this.bookedModules);
        // console.log("-------> saveBooking new booked modules: ", newModules );
        // console.log("-------> saveBooking removed booked modules: ", removedModules );
        // return;
      //end test


    this.tenantService.updateProject(project, this.tenantService.currentTenantName).subscribe({
      next: (data: any) => {
        var newModules = this.checkModulesAdded(this.oldBookedModules, this.bookedModules);
        var removedModules = this.checkModulesRemoved(this.oldBookedModules, this.bookedModules);
 
        // increase und decrease MUESSEN sequenziell laufen, nicht parallel:
        // beide aendern denselben TENANTS-Datensatz. Gleichzeitig gefeuert fuehrten
        // sie zu zwei ueberlappenden Server-Transaktionen und damit zu einem
        // Firebird-Deadlock ("update conflicts with concurrent update").
        const runDecrease = () => {
          if (removedModules.length > 0) {
            this.tenantService.decreaseNumberTenantModules(this.tenantService.currentTenantName, this.tenantService.currentTenantId, removedModules.map(m => m.moduleId)).subscribe({
              next:() => {
                // this.notificationService.success(``, 'Mandant erfolgreich aktualisiert');
              },
              error:(error:any) => {
                this.notificationService.error(``, 'update-tenant-failed decrease number' + ': ' + error.message);
              }
            });
          }
        };

        if (newModules.length > 0) {
          this.tenantService.increaseNumberTenantModules(this.tenantService.currentTenantName,this.tenantService.currentTenantId, newModules.map(m => m.moduleId)).subscribe({
            next:() => {
              // this.notificationService.success(``, 'Mandant erfolgreich aktualisiert');
              runDecrease();
            },
            error:(error:any) => {
              this.notificationService.error(``, 'update-tenant-failed increase number' + ': ' + error.message);
              runDecrease();
            }
          });
        } else {
          runDecrease();
        } 

        this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${project.display_Name} - ${this.translate.data["PROJECTUPDATED"]} `);
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["UPDATEPROJECTERROR"]} - ${project.display_Name}`)
    });
    }
  }
  checkModulesRemoved(oldBookedModules: BookedProjectModules[], bookedModules: BookedProjectModules[]): BookedProjectModules[] {
    return oldBookedModules.filter(oldModule => 
      !bookedModules.some(newModule => newModule.moduleId === oldModule.moduleId)
    );
  }
  checkModulesAdded(oldBookedModules: BookedProjectModules[], bookedModules: BookedProjectModules[]): BookedProjectModules[] {
    return bookedModules.filter(newModule => 
      !oldBookedModules.some(oldModule => oldModule.moduleId === newModule.moduleId)
    );
  }

  cancel() {
    // this.tenantService.currentTenantName = "SM";
    // this.tenantService.currentTenantId = "";
    this.router.navigate(['/', this.tenantService.currentTenantName, 'manage-projects']);
  }

  addModule() {
    const dialogRef = this.dialog.open(AddProjectModulesDialogComponent, { width: '800px', data: this.bookedModules });
      dialogRef.afterClosed().subscribe((result: any) => { 
        this.bookedModules = (result != undefined && result != null) ? result : [];

        console.log("-------> add-project-modules-dialog result modules: ", this.bookedModules)
        const jsonData = JSON.stringify(this.bookedModules);
        this.editProjectForm.get('bookedModules')!.setValue(jsonData);    
        
        this.saveBooking();
      },
      //error
    );
  }
}
